export default el => {
	const pins = el.querySelectorAll('.js-pin');
	const sliders = el.querySelectorAll('.js-slider');

	pins.forEach((pin, i) => {
		pin.onclick = () => {
			goToPin(i);
		}

		pin.onmouseover = () => {
			sliders[i].classList.add('hover');
		}

		pin.onmouseout = () => {
			sliders[i].classList.remove('hover');
		}
	})

	sliders.forEach((slider, i) => {
		slider.onmouseover = () => {
			pins[i].classList.add('hover');
		}

		slider.onmouseout = () => {
			pins[i].classList.remove('hover');
		}
	})

    const goToPin = (i) => {
    	pins.forEach((pin, j) => {
    		pin.classList[i == j ? 'add' : 'remove']('active');
    	})

    	sliders.forEach((slider, j) => {

    		if (i == j) {
    			slider.classList.add('active');
    			return;
    		}
    		
    		if (slider.classList.contains('active')) {
    			slider.classList.add('inactive');

    			slider.addEventListener('transitionend', () => {
    				slider.classList.remove('inactive');
    				slider.classList.remove('active');
    			}, { once: true })
    		}
    		// slider.classList[i == j ? 'add' : 'remove']('active');
    	})
    }
};
